<script>
// 新增寵物form
import lazyLoadComponent from '@router/lazyload-component'
import { cloneDeep } from 'lodash'
import { currentQuestionList } from '@utils/pet-question'
import petQ from '@src/mixins/petQ'
export default {
  components: {
    // BaseInputFloatingLabel: () => lazyLoadComponent(import('@components/BaseInputFloatingLabel')),
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    // CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
  },
  mixins: [petQ],
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Array,
      default: () => [],
    },
    currentStoreAlias: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tryingStore: false,
      questions: cloneDeep(currentQuestionList(this.currentStoreAlias || '')),
      submitData: {
        categoryId: '',
        sizeId: '',
        name: '',
        birthday: '',
        avatar: '',
        gender: '',
        breed: '',
        note: '',
        memberId: this.defaultValue.id,
        questions: {
          personality: [],
          vaccine: 0,
        },
      },
      behavior: [],
      healthy: [],
      parentCategoryIndex: 0,
    }
  },
  computed: {
    submitRules() {
      return {
        avatar: [
          {
            required: true,
            message: '請上傳頭像',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: `請填寫${this.$t('reserve.CLIENT')}名`,
            trigger: 'blur',
          },
        ],
        categoryId: [
          {
            required: true,
            message: '請選擇類別',
            trigger: 'change',
          },
        ],
        sizeId: [
          {
            required: true,
            message: `請選擇${this.$t('member.BODY_TO_TYPE')}`,
          },
        ],
        gender: [
          {
            required: true,
            message: '請選擇性別',
            trigger: 'change',
          },
        ],
        birthday: [
          {
            required: true,
            message: '請選擇生日',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  watch: {
    'submitData.categoryId': function() {
      this.getParentCategoryIndex()
    },
  },
  created() {
    // 在create時，將questions初始化（融合進mixin的資料）
    const mixinObj = Object.assign({}, this.submitData.questions, this.composeQToArr)
    this.$set(this.submitData, 'questions', mixinObj)
    this.initWatch()
  },
  methods: {
    /**
     * @description watch監控每一個問題
     */
    initWatch() {
      try {
        this.targetMappingArray.forEach((property) => {
          this.$watch(property, (value) => {
            if (value.length > 0 && this.submitData.questions[property]) {
              return this.findSelected(property, value)
            }
          })
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    findSelected(key, val) {
      try {
        if (Array.isArray(val)) {
          this.submitData.questions[key] = val.map((item) => {
            const selected = this.questions[key].find((i) => {
              return i.title === item
            })
            return selected
          })
        }
        if (typeof val === 'string') {
          this.submitData.questions[key] = this.questions[key].find((item) => item.name === val)
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    findTitleText(keyArr) {
      try {
        keyArr.forEach((key) => {
          if (Array.isArray(this.submitData.questions[key])) {
            this.submitData.questions[key].forEach((item) => {
              this.questions[key].forEach((i) => {
                if (item.title === i.title) {
                  item.text = i.text
                }
              })
            })
          }
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    async tryToStore() {
      await this.$refs.form.validate()
      this.tryingStore = true
      try {
        this.findTitleText(this.targetMappingArray)
        await this.$store.dispatch('member/storeSinglePet', this.submitData)
        this.emitClose()
      } finally {
        this.tryingStore = false
      }
    },
    emitClose() {
      this.$emit('close')
      this.$refs.form.resetFields()
      this.submitData.avatar = ''
    },
    getParentCategoryIndex() {
      this.category.forEach((item, index) => {
        if (this.submitData.categoryId === item.id) {
          this.parentCategoryIndex = index
        }
      })
    },
    changeCategory() {
      this.submitData.sizeId = ''
    },
  },
}
</script>

<template>
  <div>
    <el-form ref="form" :model="submitData" :rules="submitRules" label-position="left" class="el-form--floating" :validate-on-rule-change="false" label-width="100px">
      <el-form-item class="isAvatar">
        <BaseUpload v-model="submitData.avatar" resource="pet" dir="pet" circle />
      </el-form-item>
      <el-form-item prop="name" :label="`${$t('reserve.CLIENT')}名`" class="el-form-item--normal-margin">
        <el-input v-model="submitData.name" :placeholder="`請輸入${$t('reserve.CLIENT')}名`" class="bg-white is-border"></el-input>
      </el-form-item>
      <el-form-item label="類別" prop="categoryId" class="el-form-item--normal-margin">
        <el-select v-model="submitData.categoryId" class="is-border" @change="changeCategory">
          <el-option v-for="(item, index) in category" :key="index" :value="item.id" :label="item.title"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="`${$t('member.BODY_TO_TYPE')}`" prop="sizeId" class="el-form-item--normal-margin">
        <el-select v-model="submitData.sizeId" class="is-border">
          <template v-if="submitData.categoryId">
            <el-option v-for="(item, index) in category[parentCategoryIndex].children" :key="index" :label="item.title" :value="item.id"></el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item v-if="$merchantI18n() === 'pet'" prop="breed" label="品種" class="el-form-item--normal-margin">
        <el-input v-model="submitData.breed" placeholder="請輸入品種" class="bg-white is-border"></el-input>
      </el-form-item>
      <el-form-item label="性別" class="el-form-item--normal-margin">
        <el-select v-model="submitData.gender" class="is-border">
          <el-option :label="`${$t('sex.Female')}`" value="female"></el-option>
          <el-option :label="`${$t('sex.Male')}`" value="male"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生日" class="el-form-item--normal-margin">
        <el-date-picker v-model="submitData.birthday" type="date" value-format="yyyy-MM-dd" class="bg-white is-border"></el-date-picker>
      </el-form-item>
      <template v-if="$merchantI18n() === 'pet'">
        <el-form-item label="個性" class="el-form-item--normal-margin">
          <el-checkbox-group v-model="submitData.questions.personality">
            <el-checkbox v-for="item in questions.personality" :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="健康狀況" class="el-form-item--normal-margin">
          <el-checkbox-group v-model="healthy">
            <template v-for="item in questions.healthy">
              <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
              <el-input v-if="healthy.includes('其他疾病') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫其他疾病" />
            </template>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="行為" class="el-form-item--normal-margin">
          <el-checkbox-group v-model="behavior">
            <template v-for="item in questions.behavior">
              <div :key="item.title" class="inline-checkbox-input">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }} </el-checkbox>
                <el-input v-model="item.text" class="bg-white is-border" />
              </div>
            </template>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="疫苗" class="el-form-item--normal-margin">
          <el-radio v-model="submitData.questions.vaccine" :label="1">1 劑</el-radio>
          <el-radio v-model="submitData.questions.vaccine" :label="2">2 劑</el-radio>
          <el-radio v-model="submitData.questions.vaccine" :label="3">3 劑</el-radio>
        </el-form-item>
      </template>

      <template v-if="$merchantI18n() === 'beauty'">
        <!-- glow 表單 -->
        <template v-if="currentStoreAlias === 'glow-headspa'">
          <el-form-item label="婚姻狀況" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.marriage">
              <template v-for="item in questions.marriage">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="居住地址" class="el-form-item--normal-margin">
            <el-input v-model="submitData.questions.homeAddress" placeholder="請填寫地址"></el-input>
          </el-form-item>
          <el-form-item label="電子信箱" class="el-form-item--normal-margin">
            <el-input v-model="submitData.questions.email" placeholder="請填寫地址"></el-input>
          </el-form-item>
          <el-form-item label="是否希望DM郵件" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.DM">
              <template v-for="item in questions.DM">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="職業" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.job">
              <template v-for="item in questions.job">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="job === 'other' && item.name === 'other'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫職業" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="工作地址" class="el-form-item--normal-margin">
            <el-input v-model="submitData.questions.workingAddress" placeholder="請填寫地址"></el-input>
          </el-form-item>
          <el-form-item label="來店契機" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="reasons">
              <template v-for="item in questions.reasons">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="reasons.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="健康狀態" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="healthStatus">
              <template v-for="item in questions.healthStatus">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="healthStatus.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫健康狀態" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="體質/疾病" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="disease">
              <template v-for="item in questions.disease">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="disease.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫病名" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="近期壓力狀況" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="pressure">
              <template v-for="item in questions.pressure">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="是否會過敏" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="allergy">
              <template v-for="item in questions.allergy">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="allergy.includes('有') && item.name === 'yes'" :key="item.title" v-model="item.text" placeholder="請填寫過敏原" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="服用藥物" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="medicine">
              <template v-for="item in questions.medicine">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="medicine.includes('其他醫生開立之處方籤') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫藥物名稱" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="睡眠品質" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="sleepQuality">
              <template v-for="item in questions.sleepQuality">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="飲食習慣" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="eatingHabits">
              <template v-for="item in questions.eatingHabits">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="eatingHabits.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item label="來店主要目的" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="purposes">
              <template v-for="item in questions.purposes">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="purposes.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="近期頭皮狀況" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="scalpProblemRecently">
              <template v-for="item in questions.scalpProblemRecently">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="scalpProblemRecently.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="近期頭髮狀況" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="hairProblem">
              <template v-for="item in questions.hairProblem">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="hairProblem.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="洗髮頻率" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="hairWashFrequency">
              <template v-for="item in questions.hairWashFrequency">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="hairWashFrequency.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="頭皮出油狀況" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="oilyScalpProblem">
              <template v-for="item in questions.oilyScalpProblem">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="頭皮屑狀況" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="dandruffProblem">
              <template v-for="item in questions.dandruffProblem">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="過去頭皮狀況" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="scalpProblemPast">
              <template v-for="item in questions.scalpProblemPast">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="過去使用洗護產品類型" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="hairCareProducts">
              <template v-for="item in questions.hairCareProducts">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="hairCareProducts.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="曾接受專業頭皮護理" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="hasScalpCareService">
              <template v-for="item in questions.hasScalpCareService">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="hasScalpCareService.includes('是') && item.name === 'yes'" :key="item.title" v-model="item.text" placeholder="請填寫" />
              </template>
            </el-checkbox-group>
          </el-form-item>
        </template>
        <!-- 心傳表單 -->
        <template v-else-if="currentStoreAlias === 'shinden'">
          <h5>淨毛諮詢診療紀錄卡</h5>
          <el-form-item label="請在您認為合適的選項打勾" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="submitData.questions.medicalHistory">
              <template v-for="item in questions.medicalHistory">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="submitData.questions.medicalHistory.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="正在接受疾病治療嗎？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.curingForHair">
              <template v-for="item in questions.curingForHair">
                <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.curingForHair === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫病名" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="正在服用藥物嗎？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.medicationStatusForHair">
              <template v-for="item in questions.medicationStatusForHair">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="健康狀態如何?" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.healthStatusForHair">
              <template v-for="item in questions.healthStatusForHair">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.healthStatusForHair === 'poor' && item.name === 'poor'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生理期狀態如何？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.menstrualPeriodStatusForHair">
              <template v-for="item in questions.menstrualPeriodStatusForHair">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.menstrualPeriodStatusForHair === 'none' && item.name === 'none'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="以前有過皮膚問題嗎？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.skinProblemsForHair">
              <template v-for="item in questions.skinProblemsForHair">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.skinProblemsForHair === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否曾進行或預定進行大型手術？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.majorSurgery">
              <template v-for="item in questions.majorSurgery">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.majorSurgery === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否曾進行醫美手術或正在恢復期？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.cosmeticSurgeryForHair">
              <template v-for="item in questions.cosmeticSurgeryForHair">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.cosmeticSurgeryForHair === 'yes' && item.name === 'yes'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否曾經或將要接受陽光曝曬？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.sunExposureForHair">
              <template v-for="item in questions.sunExposureForHair">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.sunExposureForHair === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否曾經接受淨毛手術？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.hairRemovalSurgery">
              <template v-for="item in questions.hairRemovalSurgery">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.hairRemovalSurgery === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="自行處理的方式是？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.selfHairRemoval">
              <template v-for="item in questions.selfHairRemoval">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.selfHairRemoval === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="您在意的部位是？" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="submitData.questions.bodyParts">
              <template v-for="item in questions.bodyParts">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="submitData.questions.bodyParts.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="本次來店的契機？" class="el-form-item--normal-margin">
            <el-input v-model="reasonsForShinden" placeholder="請輸入"></el-input>
          </el-form-item>
          <el-form-item label="施術的關注點？" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="submitData.questions.focus">
              <template v-for="item in questions.focus">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="submitData.questions.focus.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <h5>『淨 kiyo』臉部諮詢紀錄卡</h5>
          <el-form-item label="健康狀態如何?" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.healthStatusForFace">
              <template v-for="item in questions.healthStatusForFace">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.healthStatusForFace === 'poor' && item.name === 'poor'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生理期狀態如何？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.menstrualPeriodStatusForFace">
              <template v-for="item in questions.menstrualPeriodStatusForFace">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.menstrualPeriodStatusForFace === 'irregular' && item.name === 'irregular'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生理痛狀態如何？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.menstrualPainForFace">
              <template v-for="item in questions.menstrualPainForFace">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.menstrualPainForFace === 'yes' && item.name === 'yes'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="過敏狀態如何？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.allergyForFace">
              <template v-for="item in questions.allergyForFace">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.allergyForFace === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否有治療中疾病？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.curingForFace">
              <template v-for="item in questions.curingForFace">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.curingForFace === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否有服用藥物？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.medicationStatusForFace">
              <template v-for="item in questions.medicationStatusForFace">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.medicationStatusForFace === 'yes' && item.name === 'yes'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否佩戴隱形眼鏡？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.contactLenses">
              <template v-for="item in questions.contactLenses">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否接受陽光曝曬？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.sunExposureForFace">
              <template v-for="item in questions.sunExposureForFace">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否接受過其他醫美服務？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.otherMedicalBeautyForFace">
              <template v-for="item in questions.otherMedicalBeautyForFace">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.otherMedicalBeautyForFace === 'yes' && item.name === 'yes'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="曾做過臉部美容手術或正在術後恢復嗎？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.cosmeticSurgeryForFace">
              <template v-for="item in questions.cosmeticSurgeryForFace">
                <el-radio :key="item.name" :label="item.name" class="mb-3">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.cosmeticSurgeryForFace === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="進行過雷射美容嗎？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.laserBeauty">
              <template v-for="item in questions.laserBeauty">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.laserBeauty === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="曾有過皮膚問題嗎？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.skinProblemsForFace">
              <template v-for="item in questions.skinProblemsForFace">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.skinProblemsForFace === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="日常肌膚管理？" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="submitData.questions.skinCareProducts">
              <template v-for="item in questions.skinCareProducts">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="submitData.questions.skinCareProducts.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="使用過美顏儀器嗎？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.beautyEquipment">
              <template v-for="item in questions.beautyEquipment">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.beautyEquipment === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="肌膚問題" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="submitData.questions.skinProblemsSelectForFace">
              <template v-for="item in questions.skinProblemsSelectForFace">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="submitData.questions.skinProblemsSelectForFace.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <h5>『淨』日式純手技諮詢紀錄卡</h5>
          <el-form-item label="健康狀態如何?" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.healthStatusForHand">
              <template v-for="item in questions.healthStatusForHand">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.healthStatusForHand === 'poor' && item.name === 'poor'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生理期狀態如何？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.menstrualPeriodStatusForHand">
              <template v-for="item in questions.menstrualPeriodStatusForHand">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.menstrualPeriodStatusForHand === 'irregular' && item.name === 'irregular'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生理痛狀態如何？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.menstrualPainForHand">
              <template v-for="item in questions.menstrualPainForHand">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.menstrualPainForHand === 'yes' && item.name === 'yes'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="壓力狀態如何？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.pressureStatus">
              <template v-for="item in questions.pressureStatus">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.pressureStatus === 'other' && item.name === 'other'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="體質" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="submitData.questions.constitution">
              <template v-for="item in questions.constitution">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="submitData.questions.constitution.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="是否有治療中疾病？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.curingForHand">
              <template v-for="item in questions.curingForHand">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.curingForHand === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="過敏狀態如何？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.allergyForHand">
              <template v-for="item in questions.allergyForHand">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input v-if="submitData.questions.allergyForHand === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫" class="mt-3"></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否有服用藥物？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.medicationStatusForHand">
              <template v-for="item in questions.medicationStatusForHand">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.medicationStatusForHand === 'yes' && item.name === 'yes'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="起床時間" class="el-form-item--normal-margin">
            <div class="d-flex">
              <el-input v-model="submitData.questions.wackUpTime" />
              <span class="ml-2">點</span>
            </div>
          </el-form-item>
          <el-form-item label="就寢時間" class="el-form-item--normal-margin">
            <div class="d-flex">
              <el-input v-model="submitData.questions.sleepTime" />
              <span class="ml-2">點</span>
            </div>
          </el-form-item>
          <el-form-item label="睡眠狀態" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.sleepStatus">
              <template v-for="item in questions.sleepStatus">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="休假" class="el-form-item--normal-margin">
            <div class="d-flex">
              <span class="mr-2" style="width: 40px">一週</span>
              <el-input v-model="submitData.questions.holidays" />
              <span class="ml-2">日</span>
            </div>
          </el-form-item>
          <el-form-item label="活動" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.activities">
              <template v-for="item in questions.activities">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否有懷孕可能？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.preparingForPregnancy">
              <template v-for="item in questions.preparingForPregnancy">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.preparingForPregnancy === 'yes' && item.name === 'yes'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫月數"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="身高" class="el-form-item--normal-margin">
            <div class="d-flex">
              <el-input v-model="submitData.questions.height" />
              <span class="ml-2" style="width: 40px">cm</span>
            </div>
          </el-form-item>
          <el-form-item label="體重" class="el-form-item--normal-margin">
            <div class="d-flex">
              <el-input v-model="submitData.questions.weight" />
              <span class="ml-2" style="width: 40px">kg</span>
            </div>
          </el-form-item>
          <el-form-item label="飲食習慣" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.eatingStatus">
              <template v-for="item in questions.eatingStatus">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="飲食" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.eatingHabits">
              <template v-for="item in questions.eatingHabits">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="嗜好" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="submitData.questions.hobby">
              <template v-for="item in questions.hobby">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="身體煩惱" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="submitData.questions.healthProblemsForHand">
              <template v-for="item in questions.healthProblemsForHand">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="submitData.questions.healthProblemsForHand.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="肌膚問題" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="submitData.questions.skinProblemsForHand">
              <template v-for="item in questions.skinProblemsForHand">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="submitData.questions.skinProblemsForHand.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="是否去過他家美容院？" class="el-form-item--normal-margin">
            <el-radio-group v-model="submitData.questions.otherMedicalBeautyForHand">
              <template v-for="item in questions.otherMedicalBeautyForHand">
                <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                <el-input
                  v-if="submitData.questions.otherMedicalBeautyForHand === 'yes' && item.name === 'yes'"
                  :key="`${item.name}-input`"
                  v-model="item.text"
                  placeholder="請填寫"
                  class="mt-3"
                ></el-input>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="每月美容消費" class="el-form-item--normal-margin">
            <div class="d-flex">
              <span class="mr-2" style="width: 20px">約</span>
              <el-input v-model="submitData.questions.beautyExpenses" />
              <span class="ml-2">元</span>
            </div>
          </el-form-item>
        </template>
        <!-- 預設表單 -->
        <template v-else>
          <el-form-item label="備孕/懷孕" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="pregnant">
              <template v-for="item in questions.pregnant">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="pregnant.includes('懷孕中') && item.name === 'pregnant'" :key="item.title" v-model="item.text" placeholder="請填寫週數" />
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="生活狀況" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="livinCondition">
              <template v-for="item in questions.livinCondition">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="livinCondition.includes('藥物') && item.name === 'drug'" :key="item.title" v-model="item.text" placeholder="請填寫藥物" />
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="健康狀態" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="healthStatus">
              <template v-for="item in questions.healthStatus">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="healthStatus.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫健康狀態" />
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="肌膚狀態" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="skinCondition">
              <template v-for="item in questions.skinCondition">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="skinCondition.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫肌膚狀態" />
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="有無開刀史" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="historyOfSurgery">
              <template v-for="item in questions.historyOfSurgery">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="historyOfSurgery.includes('有') && item.name === 'yes'" :key="item.title" v-model="item.text" placeholder="請填寫部位" />
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="膚質" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="skinType">
              <template v-for="item in questions.skinType">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="防曬狀況" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="sunProtectionStatus">
              <template v-for="item in questions.sunProtectionStatus">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="防曬習慣" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="sunProtectionHabits">
              <template v-for="item in questions.sunProtectionHabits">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="sunProtectionHabits.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫其他習慣" />
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="卸妝產品類型" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="makeupRemoverType">
              <template v-for="item in questions.makeupRemoverType">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="makeupRemoverType.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫產品類型" />
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="使用的保養品" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="skinCareProductsUsed">
              <template v-for="item in questions.skinCareProductsUsed">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="skinCareProductsUsed.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫使用的保養品" />
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="近期醫美療程" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="recentMedicalTreatment">
              <template v-for="item in questions.recentMedicalTreatment">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="recentMedicalTreatment.includes('療程名稱') && item.name === 'name'" :key="item.title" v-model="item.text" placeholder="請填寫療程名稱" />
                <el-input v-if="recentMedicalTreatment.includes('日期') && item.name === 'date'" :key="item.title" v-model="item.text" placeholder="請填寫日期" />
              </template>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="希望解決的肌膚問題" class="el-form-item--normal-margin">
            <el-checkbox-group v-model="skinProblemYouWantToSolve">
              <template v-for="item in questions.skinProblemYouWantToSolve">
                <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-if="skinProblemYouWantToSolve.includes('最近膚況變化') && item.name === 'recent-skin-changes'" :key="item.title" v-model="item.text" placeholder="請填寫部位" />
              </template>
            </el-checkbox-group>
          </el-form-item>
        </template>
      </template>

      <el-form-item class="not-inline" label="內部備註">
        <el-input v-model="submitData.note" type="textarea" :autosize="{ minRows: 3 }" class="bg-white is-border" />
      </el-form-item>
    </el-form>
    <div :class="$style.footer">
      <el-button class="is-round" @click="emitClose"> <BaseIcon name="times" /> 取消 </el-button>
      <el-button class="is-round" type="primary" :loading="tryingStore" @click="tryToStore"> <BaseIcon name="check" /> 儲存 </el-button>
    </div>
  </div>
</template>
<style lang="scss" module>
.footer {
  text-align: right;
}
</style>
